'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterInvalidAddons = exports.generateUrlWithQueryParams = exports.getInitialCalculatorState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.useMergeState = useMergeState;

var _react = require('react');

var _underscore = require('underscore');

var _params = require('hub-http/helpers/params');

var _Terms = require('self-service-api/constants/Terms');

var _Editions = require('self-service-api/constants/Editions');

var _immutable = require('immutable');

var _store = require('pricing-pages-unified-ui/utils/store');

var _store2 = _interopRequireDefault(_store);

var _ConfigSelectors = require('pricing-pages-unified-ui/selectors/ConfigSelectors');

var _validators = require('pricing-pages-unified-ui/utils/validators');

var _HubToAddonsMap = require('pricing-pages-unified-ui/constants/HubToAddonsMap');

var _HubToAddonsMap2 = _interopRequireDefault(_HubToAddonsMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getInitialCalculatorState = exports.getInitialCalculatorState = function getInitialCalculatorState() {
  var queryString = window.location.search.replace('?', '');
  var params = (0, _params.parse)(queryString);

  var edition = params.edition,
      term = params.term,
      contacts = params.contacts,
      sales_seats = params.sales_seats,
      service_seats = params.service_seats,
      addons = params.addons,
      services = params.services;


  var initialState = {
    activeEdition: _Editions.STARTER,
    activeTerm: _Terms.MONTHLY,
    marketingUnits: 0,
    salesUnits: 0,
    serviceUnits: 0,
    selectedAddOns: (0, _immutable.Set)(),
    selectedServices: (0, _immutable.Set)()
  };

  if ((0, _validators.validateEdition)(edition)) initialState.activeEdition = edition;
  if ((0, _validators.validateTerm)(term)) initialState.activeTerm = term;
  if ((0, _validators.validateAdditionalUnitQuantity)(contacts)) initialState.marketingUnits = JSON.parse(contacts);
  if ((0, _validators.validateAdditionalUnitQuantity)(sales_seats)) initialState.salesUnits = JSON.parse(sales_seats);
  if ((0, _validators.validateAdditionalUnitQuantity)(service_seats)) initialState.serviceUnits = JSON.parse(service_seats);

  var isAppAuth = (0, _ConfigSelectors.isAppAuthSelector)(_store2.default.getState());
  if (!isAppAuth) {
    var _parseList = function _parseList(list) {
      try {
        var parsedList = !Array.isArray(list) ? [JSON.parse(list)] : list.map(JSON.parse);

        return parsedList;
      } catch (e) {
        return [];
      }
    };

    var parsedAddons = _parseList(addons);
    var parsedServices = _parseList(services);

    if ((0, _validators.validateAddons)(parsedAddons)) {
      initialState.selectedAddOns = (0, _immutable.Set)(parsedAddons);
    }

    if ((0, _validators.validateServices)(parsedServices)) {
      initialState.selectedServices = (0, _immutable.Set)(parsedServices);
    }
  }

  return initialState;
};

function useMergeState() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = (0, _react.useState)(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var mergeState = function mergeState(nextState) {
    return setState(_extends({}, state, nextState));
  };
  return [state, mergeState];
}

var generateUrlWithQueryParams = exports.generateUrlWithQueryParams = function generateUrlWithQueryParams(_ref) {
  var activeEdition = _ref.activeEdition,
      activeTerm = _ref.activeTerm,
      marketingUnits = _ref.marketingUnits,
      salesUnits = _ref.salesUnits,
      serviceUnits = _ref.serviceUnits,
      selectedAddOns = _ref.selectedAddOns,
      selectedServices = _ref.selectedServices;
  var _window$location = window.location,
      origin = _window$location.origin,
      pathname = _window$location.pathname,
      search = _window$location.search;

  var rootUrl = '' + origin + pathname;

  var params = _extends({}, (0, _params.parse)(search.replace('?', '')), {
    edition: activeEdition,
    term: activeTerm
  });

  if (marketingUnits && marketingUnits > 0) params.contacts = marketingUnits;
  if (salesUnits && salesUnits > 0) params.sales_seats = salesUnits;
  if (serviceUnits && serviceUnits > 0) params.service_seats = serviceUnits;
  if (selectedAddOns) params.addons = selectedAddOns.toArray();
  if (selectedServices) params.services = selectedServices.toArray();

  var queryString = (0, _params.stringify)(params);

  return queryString ? rootUrl + '?' + queryString : rootUrl;
};

// Used to ensure addons that are specific to an edition
// don't get carried over when switching to new edition
var filterInvalidAddons = exports.filterInvalidAddons = function filterInvalidAddons(addons, hub, currentEdition, nextEdition) {
  if (!addons || addons.length === 0) return [];

  var editionSpecificMerchMap = _HubToAddonsMap2.default[hub].editionSpecificMerchMap;


  var currentEditionHasUniqueAddons = editionSpecificMerchMap && editionSpecificMerchMap[currentEdition];
  var currentEditionSpecificAddons = currentEditionHasUniqueAddons ? editionSpecificMerchMap[currentEdition] : [];

  var nextEditionHasUniqueAddons = editionSpecificMerchMap && editionSpecificMerchMap[nextEdition];
  var nextEditionSpecificAddons = nextEditionHasUniqueAddons ? editionSpecificMerchMap[nextEdition] : [];

  var invalidAddons = (0, _underscore.difference)(currentEditionSpecificAddons, nextEditionSpecificAddons);

  var filteredAddons = addons.filter(function (addon) {
    return !invalidAddons.includes(addon);
  });

  return filteredAddons;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/stateUtils.js
// module id = 211
// module chunks = 3 4 5